

exports.cache_set = (key, value) => {
    if (value === undefined) {
        return;
    }
    if (typeof value === 'string') {
        window.localStorage.setItem(key, value)
    } else {
        window.localStorage.setItem(key, JSON.stringify(value))
    }
}

exports.cache_get = (key) => {
    const json = window.localStorage.getItem(key);
    try {
        const data = JSON.parse(json);
        return data;
    } catch(e) {
        console.log('cache_err :>> ', e);
    }
    return undefined;
}

exports.cache_remove = (key) => {
    const json = window.localStorage.removeItem(key);
}